/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Toggle_Markers_TitleInputs */



/**
* | output |
* | --- |
* | "Show/Hide Markers" |
*
* @param {Timeline_Toggle_Markers_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_toggle_markers_title = /** @type {((inputs?: Timeline_Toggle_Markers_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Toggle_Markers_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher/Masquer les marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Markierungen ein-/ausblenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra/Nascondi marcatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать/скрыть маркеры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar/ocultar marcadores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示/隐藏标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカーの表示/非表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर दिखाएँ/छिपाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mostrar/Ocultar Marcadores")
	return /** @type {LocalizedString} */ ("Show/Hide Markers")
});